import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useReferral = () => {
  const { user } = useAuth();
  const [referralCode, setReferralCode] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchReferralCode = useCallback(async () => {
    if (!user?.id) return;

    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('referral_code')
        .eq('id', user.id)
        .single();

      if (error) throw error;
      setReferralCode(data?.referral_code || null);
    } catch (error) {
      console.error('Error fetching referral code:', error);
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  // Process referral via server-side edge function (secure)
  const processReferral = useCallback(async (referrerCode: string, _newUserId: string) => {
    try {
      const { error } = await supabase.functions.invoke('process-referral', {
        body: { referralCode: referrerCode }
      });

      if (error) {
        console.error('Error processing referral:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error processing referral:', error);
      return false;
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchReferralCode();
    }
  }, [user, fetchReferralCode]);

  return {
    referralCode,
    loading,
    processReferral,
    refetch: fetchReferralCode
  };
};
